import { Controller } from "@hotwired/stimulus";

// Catalogue des packs de jetons GO4SIA (§6.3). L'utilisateur empile des unités
// de plusieurs packs ; « Continuer vers le paiement » envoie le panier à la page
// de paiement (shared/payments/_checkout), qui gère numéro, opérateur, promo et
// chiffrage. Au retour (« Modifier ma commande »), le panier est restauré.
export default class extends Controller {
  static targets = ["count", "card", "cart", "summary", "empty", "total", "after", "submit"];
  static values = { cart: Object, balance: Number, tokensPerMessage: Number, labels: Object };

  connect() {
    this.cart = { ...this.cartValue };
    this.refresh();
  }

  increment(event) {
    const id = event.currentTarget.dataset.packId;
    this.cart[id] = (this.cart[id] || 0) + 1;
    this.refresh();
  }

  decrement(event) {
    const id = event.currentTarget.dataset.packId;
    this.cart[id] = Math.max(0, (this.cart[id] || 0) - 1);
    if (!this.cart[id]) delete this.cart[id];
    this.refresh();
  }

  refresh() {
    let tokens = 0;
    let price = 0;
    this.cardTargets.forEach((card) => {
      const id = card.dataset.packId;
      const units = this.cart[id] || 0;
      tokens += parseInt(card.dataset.packTokens, 10) * units;
      price += parseInt(card.dataset.packPrice, 10) * units;
      card.classList.toggle("is-selected", units > 0);
      card.style.borderColor = units > 0 ? "var(--ds-ai)" : "";
    });
    this.countTargets.forEach((el) => {
      el.textContent = this.cart[el.dataset.packId] || 0;
    });

    const hasItems = tokens > 0;
    this.cartTarget.value = JSON.stringify(this.cart);
    this.submitTarget.disabled = !hasItems;
    this.emptyTarget.classList.toggle("hidden", hasItems);
    this.summaryTarget.classList.toggle("hidden", !hasItems);
    if (!hasItems) return;

    const l = this.labelsValue;
    const after = this.balanceValue + tokens;
    const messages = Math.floor(after / (this.tokensPerMessageValue || 6500));
    this.totalTarget.textContent = l.total
      .replace("__TOKENS__", this.format(tokens))
      .replace("__PRICE__", this.format(price));
    this.afterTarget.textContent = l.after
      .replace("__TOKENS__", this.format(after))
      .replace("__MESSAGES__", this.format(messages));
  }

  format(n) {
    return Math.round(n).toLocaleString("fr-FR").replace(/ | /g, " ");
  }
}
